import React from 'react';

export const Field = ({ label, hint, children }) => (
  <div>
    <label className="block text-xs font-bold text-secondary uppercase tracking-wider mb-1">{label}</label>
    {children}
    {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
  </div>
);

export const Toggle = ({ checked, onChange, label }) => (
  <label className="flex items-center gap-2 cursor-pointer select-none text-sm">
    <input type="checkbox" className="w-4 h-4 accent-[#CD19F9]" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
    {label}
  </label>
);

export const Section = ({ title, children }) => (
  <div className="card p-5 space-y-4">
    {title && <h3 className="font-bold font-headline">{title}</h3>}
    {children}
  </div>
);

// Immutable update of schema[key] with a partial object.
export const patchSection = (schema, key, patch) => ({ ...schema, [key]: { ...(schema[key] || {}), ...patch } });
